export default __webpack_public_path__ + "static/media/primary.ea4f4b88178ebd3bd27988570dedbea9.svg";